import { AccountingCustomerRecord, PlatformCustomerRecord } from '../finance/finance-api.service';

export function formatCustomerReferenceFromPlatform(customer: PlatformCustomerRecord): string {
  const code = customer.customerCode?.trim();
  const name = customer.displayName?.trim();
  if (code && name) {
    return `${code} — ${name}`;
  }

  return name || code || customer.id;
}

export function formatCustomerReferenceFromAccounting(customer: AccountingCustomerRecord): string {
  const code = customer.code?.trim();
  const name = customer.displayName?.trim();
  if (code && name) {
    return `${code} — ${name}`;
  }

  return name || code || customer.key;
}
